const T = require('../types');

module.exports = function resetSuggest(slug) {
  return {
    type: T.SUGGEST_RESET,
    slug,
  };
};
